import React, { MouseEvent } from 'react';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import { STATUS_META, WordStatus, pickStatusColor } from './statusMeta';

const hexToRgba = (hex: string, a: number) => {
  const h = hex.replace('#', '');
  return `rgba(${parseInt(h.slice(0, 2), 16)}, ${parseInt(
    h.slice(2, 4),
    16,
  )}, ${parseInt(h.slice(4, 6), 16)}, ${a})`;
};

interface StatusChipProps {
  status: WordStatus;
  onClick?: (e: MouseEvent) => void;
}

const StatusChip: React.FC<StatusChipProps> = ({ status, onClick }) => {
  const theme = useTheme();
  const m = STATUS_META[status];
  const color = pickStatusColor(status, theme.palette.mode);

  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      spacing={0.875}
      onClick={onClick}
      sx={{
        bgcolor: hexToRgba(color, 0.12),
        border: '1px solid',
        borderColor: hexToRgba(color, 0.3),
        borderRadius: 999,
        cursor: onClick ? 'pointer' : 'default',
        pl: 1.125,
        pr: 1.375,
        py: '4px',
        transition: 'border-color .15s ease',
        whiteSpace: 'nowrap',
        '&:hover': onClick
          ? { borderColor: hexToRgba(color, 0.6) }
          : undefined,
      }}
    >
      <Box
        sx={{
          bgcolor: color,
          borderRadius: '50%',
          flex: 'none',
          height: 8,
          width: 8,
        }}
      />
      <Typography sx={{ fontSize: 13, fontWeight: 700 }}>{m.label}</Typography>
    </Stack>
  );
};

export default StatusChip;
